import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function LaalIshqVideo() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section data-testid="laal-ishq-video-section" ref={ref} className="relative w-full">
      {/* Video container */}
      <div className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          data-testid="laal-ishq-video"
          className="w-full h-full object-cover"
        >
          <source src="/videos/laal-ishq.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-[#0A0A0A]/25" />

        {/* Subtle location signature - bottom right corner */}
        <div className="absolute bottom-6 right-8 md:bottom-8 md:right-12">
          <p
            data-testid="laal-ishq-location"
            className="font-serif italic text-white/30 text-xs md:text-sm tracking-wide"
            style={{ fontStyle: 'italic' }}
          >
            Sangeet, Delhi
          </p>
        </div>
      </div>

      {/* Text after video - minimal transition */}
      <div className="bg-[#EFEAE6] py-6 md:py-8" />
    </section>
  );
}
